import React, { useEffect, useMemo, useState } from "react";
import {
  EllipsisOutlined,
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  SettingOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Col,
  Row,
  Image,
  Modal,
  Space,
  Button,
  Checkbox,
  Form,
  Input,
  Select,
  Table,
  Tag,
  Dropdown,
  Popconfirm,
  InputNumber,
  DatePicker,
  Badge,
  Spin,
} from "antd";
import propertyImage from "../../assets/img/dashboard/properties.png";
import userImage from "../../assets/img/main-wrapper/user.jpg";
import dayjs from "dayjs";
import filter from "../../assets/img/icon/filter.svg";
import { Link } from "react-router-dom";
import {
  actionGetAllProperty,
  actionDeleteProperty,
  actionGetPropertyDashboardData
} from "../../store/actions/propertyAction";
import { connect } from "react-redux";
const Property = (props) => {
  const {
    actionGetAllProperty,
    propertiesLoader,
    propertiesData,
    actionDeleteProperty,
    propertiesCount,
    deletePropertyLoader,
    actionGetPropertyDashboardData,
    propertyDashboardData,
    propertyDashboardLoader
  } = props;
  const [form] = Form.useForm();
  const [search, setSearch] = useState();
  const [sort, setSort] = useState();
  const [badgeCount, setBadgeCount] = useState();
  const [values, setValues] = useState({});
  const [modal1Open, setModal1Open] = useState(false);
  const [startYear, setStartYear] = useState();
  const [endYear, setEndYear] = useState();

  useEffect(() => {
    actionGetAllProperty(0, 10);
    actionGetPropertyDashboardData();
  }, []);

  useMemo(() => { }, [propertiesData]);

  const options = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5+", label: "5+" },
  ];

  function countNonEmptyKeys(obj) {
    let count = 0;

    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== null && obj[key] !== undefined) {
        count++;
      }
    }

    return count;
  }

  const handleChange = (fieldName, value) => {
    // console.log({ values });
    setValues({
      ...values,
      [fieldName]: value
    });
    // Counting non-empty keys in the 'values' object and setting the badge count
    setBadgeCount(countNonEmptyKeys({ ...values, [fieldName]: value }));
  }


  const onFinish = (value) => {
    const {
      beds,
      baths,
      status,
      minvalue,
      maxvalue,
      property_type,
      min_finished_square_feet,
      max_finished_square_feet,
      min_lot_size,
      max_lot_size,
      min_year_built,
      max_year_built,
      min_no_of_stories,
      max_no_of_stories,
      hoa_dues,
      parking,
      basement,
      cooling_type,
      heating_type,
      view,
    } = value;
    actionGetAllProperty(
      0,
      10,
      search,
      sort,
      status,
      minvalue && parseInt(minvalue),
      maxvalue && parseInt(maxvalue),
      beds && encodeURIComponent(beds),
      baths && encodeURIComponent(baths),
      property_type,
      min_finished_square_feet && parseInt(min_finished_square_feet),
      max_finished_square_feet && parseInt(max_finished_square_feet),
      min_lot_size && parseInt(min_lot_size),
      max_lot_size && parseInt(max_lot_size),
      min_year_built && dayjs(min_year_built).format("YYYY"),
      max_year_built && dayjs(max_year_built).format("YYYY"),
      min_no_of_stories && parseInt(min_no_of_stories),
      max_no_of_stories && encodeURIComponent(max_no_of_stories),
      hoa_dues && encodeURIComponent(hoa_dues),
      parking && parking,
      basement && basement,
      cooling_type && cooling_type,
      heating_type && heating_type,
      view && view
    );

    setModal1Open(false);
    // form.resetFields();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onClickPagination = (e) => {
    // console.log(e);
    const {
      beds,
      baths,
      status,
      minvalue,
      maxvalue,
      property_type,
      min_finished_square_feet,
      max_finished_square_feet,
      min_lot_size,
      max_lot_size,
      min_year_built,
      max_year_built,
      min_no_of_stories,
      max_no_of_stories,
      hoa_dues,
      parking,
      basement,
      cooling_type,
      heating_type,
      view,
    } = values;
    actionGetAllProperty(
      e.current - 1,
      e.pageSize,
      search,
      sort,
      status,
      minvalue && parseInt(minvalue),
      maxvalue && parseInt(maxvalue),
      beds && encodeURIComponent(beds),
      baths && encodeURIComponent(baths),
      property_type,
      min_finished_square_feet && parseInt(min_finished_square_feet),
      max_finished_square_feet && parseInt(max_finished_square_feet),
      min_lot_size && parseInt(min_lot_size),
      max_lot_size && parseInt(max_lot_size),
      min_year_built && dayjs(min_year_built).format("YYYY"),
      max_year_built && dayjs(max_year_built).format("YYYY"),
      min_no_of_stories && parseInt(min_no_of_stories),
      max_no_of_stories && encodeURIComponent(max_no_of_stories),
      hoa_dues && encodeURIComponent(hoa_dues),
      parking && parking,
      basement && basement,
      cooling_type && cooling_type,
      heating_type && heating_type,
      view && view,
    );
  };

  const confirm = (id) => {
    actionDeleteProperty(id);
  };



  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      width: 150,
      fixed: "left",
      key: "image",
      render: (image) => (
        <Badge count={image.length} offset={[16, 2]} size="default" color="#FF9A3E">
          <Image.PreviewGroup items={image}>
            <Image
              style={{ width: "70px", objectFit: "cover", aspectRatio: 3 / 3 }}
              src={image[0]}
              // src="https://gw.alipayobjects.com/zos/antfincdn/LlvErxo8H9/photo-1503185912284-5271ff81b9a8.webp"
              width={50}
              fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
              preview={{ mask: "" }}
              className="property-img-border"
            />
          </Image.PreviewGroup>
        </Badge>

      ),
    },
    {
      title: "User/Agent",
      dataIndex: "user_agent",
      key: "user_agent",
      width: 150,
    },
    {
      title: "Address",
      dataIndex: "street_address",
      key: "street_address",
      width: 200,
    },
    {
      title: "Home type",
      dataIndex: "home_type",
      key: "home_type",
      width: 150,
    },
    // {
    //   title: "City",
    //   dataIndex: "city",
    //   key: "city",
    // },
    // {
    //   title: "Zip Code",
    //   dataIndex: "zip_code",
    //   key: "zip_code",
    // },
    {
      title: "Asking Price",
      dataIndex: "asking_price",
      key: "asking_price",
      width: 150,

    },
    {
      title: "Finished Square Feet",
      dataIndex: "finished_square_feet",
      key: "finished_square_feet",
      width: 150,

    },
    {
      title: "Date Of Add",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,

    },
    {
      title: "Other Details",
      dataIndex: "other_details",
      key: "other_details",
      width: 150,

    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
      width: 150,

    },


    {
      title: (
        <>
          <Badge count={badgeCount} style={{ cursor: "pointer" }} color="#FF9A3E" onClick={() => setModal1Open(true)}>
            <Image
              src={filter}
              preview={false}
              style={{ cursor: "pointer", width: 24 }}
            />
          </Badge>

        </>
      ),
      fixed: "right",
      align: "center",
      width: "80px",
      key: "action",
      render: (_, item) => (
        <>
          <Dropdown
            placement="bottom"
            menu={{
              items: [
                {
                  label: (
                    <span>
                      <Link
                        to={`/view-property/${item._id}`}
                        style={{ color: "black" }}
                      >
                        <EyeOutlined
                          style={{
                            color: "#FF9A3E",
                            fontSize: "18px",
                            marginRight: 10,
                          }}
                        />
                        View
                      </Link>
                    </span>
                  ),
                },
                {
                  label: (
                    <span>
                      <Link
                        to={`/update-property/${item._id}`}
                        style={{ color: "black" }}
                      >
                        <EditOutlined
                          style={{
                            color: "#FF9A3E",
                            fontSize: "18px",
                            marginRight: 10,
                          }}
                        />
                        Edit
                      </Link>
                    </span>
                  ),
                },
                {
                  label: (
                    <Popconfirm
                      okButtonProps={{
                        loading: deletePropertyLoader,
                      }}
                      placement="topLeft"
                      title="Are you sure to delete this Property?"
                      onConfirm={() => confirm(item._id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <span style={{ color: "black" }}>
                        <DeleteOutlined
                          style={{
                            color: "#FF9A3E",
                            fontSize: "18px",
                            marginRight: 10,
                          }}
                        />
                        Delete
                      </span>
                    </Popconfirm>
                  ),
                },
              ],
            }}
          >
            <a>
              <EllipsisOutlined style={{ fontSize: "20px" }} />
            </a>
          </Dropdown>
        </>
      ),
    },
  ];

  const handleSortChange = (e) => {
    setSort(e);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const onFinishSearch = (value) => {
    // setSearch(value.search ? value.search : "");
    // setSort(value.sort ? value.sort : "");
    const {
      beds,
      baths,
      status,
      minvalue,
      maxvalue,
      property_type,
      min_finished_square_feet,
      max_finished_square_feet,
      min_lot_size,
      max_lot_size,
      min_year_built,
      max_year_built,
      min_no_of_stories,
      max_no_of_stories,
      hoa_dues,
      parking,
      basement,
      cooling_type,
      heating_type,
      view,
    } = values;
    actionGetAllProperty(
      0,
      10,
      value.search ? value.search : "",
      value.sort ? value.sort : "",
      status,
      minvalue && parseInt(minvalue),
      maxvalue && parseInt(maxvalue),
      beds && encodeURIComponent(beds),
      baths && encodeURIComponent(baths),
      property_type,
      min_finished_square_feet && parseInt(min_finished_square_feet),
      max_finished_square_feet && parseInt(max_finished_square_feet),
      min_lot_size && parseInt(min_lot_size),
      max_lot_size && parseInt(max_lot_size),
      min_year_built && dayjs(min_year_built).format("YYYY"),
      max_year_built && dayjs(max_year_built).format("YYYY"),
      min_no_of_stories && parseInt(min_no_of_stories),
      max_no_of_stories && encodeURIComponent(max_no_of_stories),
      hoa_dues && encodeURIComponent(hoa_dues),
      parking && parking,
      basement && basement,
      cooling_type && cooling_type,
      heating_type && heating_type,
      view && view,
    );
  };
  const getStatusTagColor = (status) => {
    // Define color mapping based on status values
    const colorMap = {
      'For Sale': '#f7a21c',
      'For Rent': '#e94894',
      'Sold': '#51b3fa',
    };
    return colorMap[status];
  };

  const tableData = [];
  propertiesData &&
    propertiesData.length > 0 &&
    propertiesData.map((e, index) => {
      tableData.push({
        key: index,
        _id: e._id,
        image: e.property_images.map((m) => m.split('.').pop() == 'mp4' ? m.replace('.mp4', '-thumb.png') : m),
        home_type: e.home_type,
        user_agent: e.user.first_name + ' ' + e.user.last_name ? e.user.first_name + ' ' + e.user.last_name : '-',
        // city: e.city,
        // zip_code: e.zip_code,
        asking_price: `$${e.asking_price.toLocaleString()}`,
        finished_square_feet: e.finished_square_feet,
        source: e.source,
        other_details: (
          <span>
            {`Bed - ${e.beds}`}
            <br />
            {`Bath - ${e.baths}`}
            <br />
            {e.parking_spaces ? `Parking - ${e.parking_spaces}` : ""}
          </span>
        ),
        createdAt: dayjs(e.createdAt).format('DD-MM-YYYY'),
        // street_address: e.street_address + ", " + e.city + ", " + e.state + ", " + e.country,
        street_address: (
          <span>
            {e.street_address}, {e.city}, {e.state}, {e.country}{' '}
            <br />
            <Tag color={getStatusTagColor(e.status)}>{e.status}</Tag>
          </span>
        ),
      });
    });

  return (
    <div>
      <Spin spinning={propertiesLoader}>
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
          <Row className="main-card-wrapper" gutter={16}>
            <Col span={6}>
              <div className="card-blue">
                <Row>
                  <Col span={18} className="text-card">
                    <p className="font-title">Open House</p>
                    <p className="font-text">{propertyDashboardData.open_house ? propertyDashboardData.open_house : 0}</p>
                  </Col>
                  <Col span={6} className="image-card-blue">
                    <Image src={propertyImage} preview={false} />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col span={6}>
              <div className="card-yellow">
                <Row>
                  <Col span={18} className="text-card">
                    <p className="font-title">For Sale</p>
                    <p className="font-text">{propertyDashboardData.for_sale ? propertyDashboardData.for_sale : 0}</p>
                  </Col>
                  <Col span={6} className="image-card-yellow">
                    <Image src={propertyImage} preview={false} />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col span={6}>
              <div className="card-pink">
                <Row>
                  <Col span={18} className="text-card">
                    <p className="font-title">For Rent</p>
                    <p className="font-text">{propertyDashboardData.for_rent ? propertyDashboardData.for_rent : 0}</p>
                  </Col>
                  <Col span={6} className="image-card-pink">
                    <Image src={propertyImage} preview={false} />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col span={6}>
              <div className="card-light-blue">
                <Row>
                  <Col span={18} className="text-card">
                    <p className="font-title">Sold</p>
                    <p className="font-text">{propertyDashboardData.sold ? propertyDashboardData.sold : 0}</p>
                  </Col>
                  <Col span={6} className="image-card-light-blue">
                    <Image src={propertyImage} preview={false} />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row
            className="main-card-wrapper"
            gutter={16}
            justify="space-around"
            align="middle"
          >
            <Col span={4} style={{ fontWeight: "bold", fontSize: "15px" }}>
              Properties
            </Col>
            <Col span={16} align="middle">
              <Form
                name="basic"
                layout="inline"
                onFinish={onFinishSearch}
                autoComplete="off"
                style={{ justifyContent: "center" }}
              >
                <Form.Item name="search">
                  <Input
                    onChange={handleSearch}
                    placeholder="Search Here"
                    allowClear
                  />
                </Form.Item>
                <Form.Item name="sort" className="fixed-select">
                  <Select
                    allowClear
                    showSearch
                    onChange={handleSortChange}
                    placeholder="Select Sort"
                    optionFilterProp="children"
                    style={{ minWidth: "100px" }}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={[
                      {
                        value: "In 2 day",
                        label: "In 2 day",
                      },
                      {
                        value: "In this week",
                        label: "In this week",
                      },
                      {
                        value: "In this month",
                        label: "In this month",
                      },
                      {
                        value: "Bedroom",
                        label: "Bedroom",
                      },
                      {
                        value: "Bathroom",
                        label: "Bathroom",
                      },
                      {
                        value: "Square feet",
                        label: "Square feet",
                      },
                      {
                        value: "Lot Size",
                        label: "Lot Size",
                      },
                      {
                        value: "Price low to high",
                        label: "Price low to high",
                      },
                      {
                        value: "Price high to low",
                        label: "Price high to low",
                      },
                    ]}
                  />
                </Form.Item>

                <Form.Item>
                  <Button htmlType="submit">Search</Button>
                </Form.Item>
                {/*               
              <Image
                src={filter}
                preview={false}
                style={{ cursor: "pointer", width: 24 }}
                onClick={() => setModal1Open(true)}
              /> */}
                {/* <Button
                onClick={() => setModal1Open(true)}
                type="primary"
                icon={
                  // <>
                  //   <Image
                  //     src={filter}
                  //     preview={false}
                  //     style={{ cursor: "pointer", width: 24 }}
                  //     onClick={() => setModal1Open(true)}
                  //   />
                  // </>
                  <SearchOutlined />
                }
              >
                Advance Filter
              </Button> */}
              </Form>

              <Modal
                className="filter-modal"
                title="Filter"
                width={700}
                style={{ top: 20 }}
                open={modal1Open}
                footer={false}
                onOk={() => setModal1Open(false)}
                onCancel={() => setModal1Open(false)}
              >
                <Row>
                  <Col span={24}>
                    <Form
                      autoComplete="off"
                      form={form}
                      layout="vertical"
                      size="large"
                      onFinish={onFinish}
                      onFinishFailed={onFinishFailed}
                    >
                      <Row gutter={[16, 0]}>
                        <Col span={12}>
                          <Form.Item
                            colon={false}
                            // label="Status"
                            name="status"
                            rules={[
                              {
                                required: false,
                                message: "Please Select Status!",
                              },
                            ]}
                          >
                            <Select
                              onChange={(value) => handleChange('status', value)}
                              allowClear
                              showSearch
                              placeholder="Select a Status"
                              // defaultValue={"For Sale"}

                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                { value: "For Sale", label: "For Sale" },
                                { value: "For Rent", label: "For Rent" },
                                { value: "Sold", label: "Sold" },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            colon={false}
                            name="beds"
                            rules={[
                              {
                                required: false,
                                message: "Please select the number of beds!",
                              },
                            ]}
                          >
                            <Select
                              onChange={(value) => handleChange('beds', value)}
                              allowClear
                              showSearch
                              placeholder="Beds"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                            >
                              {options.map((option) => (
                                <Select.Option
                                  key={option.value}
                                  value={option.value}
                                >
                                  {option.label}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            colon={false}
                            className="mb-0"
                            name="baths"
                            rules={[
                              {
                                required: false,
                                message: "Please enter Baths*!",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              showSearch
                              placeholder="Baths"
                              // defaultValue={"For Sale"}
                              onChange={(value) => handleChange('baths', value)}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                { value: "1", label: "1" },
                                { value: "1.5", label: "1.5" },
                                { value: "2", label: "2" },
                                { value: "2.5", label: "2.5" },
                                { value: "3+", label: "3+" },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            className="mb-0"
                            colon={false}
                            name="property_type"
                            rules={[
                              {
                                required: false,
                                message: "Please enter Property Type*!",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              showSearch
                              placeholder="Property Type"
                              optionFilterProp="children"
                              onChange={(value) => handleChange('property_type', value)}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                {
                                  value: "Single Family",
                                  label: "Single Family",
                                },
                                { value: "Condo", label: "Condo" },
                                { value: "Townhomes", label: "Townhomes" },
                                { value: "Apartment", label: "Apartment" },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Row gutter={[16, 0]} align="middle">
                            <Col span={11}>
                              <Form.Item
                                label="Price"
                                colon={false}
                                name="minvalue"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Min Price*!",
                                  },
                                ]}
                              >
                                <InputNumber
                                  type="number"
                                  onChange={(value) => handleChange('min_price', value)}
                                  style={{ width: "100%" }}
                                  placeholder="Min Price"
                                  min={0}
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              span={2}
                              align="middle"
                              style={{ marginTop: 12 }}
                            >
                              <span>-</span>
                            </Col>
                            <Col span={11} className="hidden-label">
                              <Form.Item
                                label="Price"
                                colon={false}
                                name="maxvalue"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Max Price*!",
                                  },
                                ]}
                              >
                                <InputNumber
                                  type="number"
                                  onChange={(value) => handleChange('max_price', value)}
                                  style={{ width: "100%" }}
                                  placeholder="Max Price"
                                  min={0}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <Row gutter={[16, 0]} align="middle">
                            <Col span={11}>
                              <Form.Item
                                label="Square Feet"
                                colon={false}
                                name="min_finished_square_feet"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Min Sqft*!",
                                  },
                                ]}
                              >
                                <Select
                                  allowClear
                                  showSearch
                                  placeholder="Min finished sq.ft"
                                  // defaultValue={"For Sale"}
                                  onChange={(value) => handleChange('min_sq_ft', value)}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  options={[
                                    { value: "0", label: "0" },
                                    { value: "250", label: "250" },
                                    { value: "500", label: "500" },
                                    { value: "750", label: "750" },
                                    { value: "1000", label: "1000" },
                                    { value: "1250", label: "1250" },
                                    { value: "1500", label: "1500" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              span={2}
                              align="middle"
                              style={{ marginTop: 12 }}
                            >
                              <span>-</span>
                            </Col>
                            <Col span={11} className="hidden-label">
                              <Form.Item
                                label="Max Sqft"
                                colon={false}
                                name="max_finished_square_feet"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Max Sqft*!",
                                  },
                                ]}
                              >
                                <Select
                                  onChange={(value) => handleChange('max_sq_ft', value)}
                                  allowClear
                                  showSearch
                                  placeholder="Max finished sq.ft"
                                  // defaultValue={"For Sale"}

                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  options={[
                                    { value: "0", label: "0" },
                                    { value: "250", label: "250" },
                                    { value: "500", label: "500" },
                                    { value: "750", label: "750" },
                                    { value: "1000", label: "1000" },
                                    { value: "1250", label: "1250" },
                                    { value: "1500+", label: "1500+" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>

                        <Col span={12}>
                          <Row gutter={[16, 0]} align="middle">
                            <Col span={11}>
                              <Form.Item
                                label="Lot Size"
                                colon={false}
                                name="min_lot_size"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Min lot size*!",
                                  },
                                ]}
                              >
                                {/* <InputNumber
                                style={{ width: "100%" }}
                                placeholder="Min lot size"
                                min={0}
                                defaultValue={0}
                              /> */}
                                <Select
                                  allowClear
                                  showSearch
                                  placeholder="Min Lot Size"
                                  // defaultValue={"For Sale"}
                                  onChange={(value) => handleChange('minLotSize', value)}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  options={[
                                    { value: "0", label: "0" },
                                    { value: "250", label: "250" },
                                    { value: "500", label: "500" },
                                    { value: "750", label: "750" },
                                    { value: "1000", label: "1000" },
                                    { value: "1250", label: "1250" },
                                    { value: "1500", label: "1500" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              span={2}
                              align="middle"
                              style={{ marginTop: 12 }}
                            >
                              <span>-</span>
                            </Col>
                            <Col span={11} className="hidden-label">
                              <Form.Item
                                label="Max Lot Size"
                                colon={false}
                                name="max_lot_size"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Max lot size*!",
                                  },
                                ]}
                              >
                                <Select
                                  allowClear
                                  showSearch
                                  placeholder="Max Lot Size"
                                  optionFilterProp="children"
                                  onChange={(value) => handleChange('maxLotSize', value)}
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  options={[
                                    { value: "0", label: "0" },
                                    { value: "250", label: "250" },
                                    { value: "500", label: "500" },
                                    { value: "750", label: "750" },
                                    { value: "1000", label: "1000" },
                                    { value: "1250", label: "1250" },
                                    { value: "1500", label: "1500" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <Row gutter={[16, 0]} align="middle">
                            <Col span={11}>
                              <Form.Item
                                label="Year built"
                                colon={false}
                                name="min_year_built"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Min Year built*!",
                                  },
                                ]}
                              >
                                <DatePicker
                                  onChange={(v, d) => { setStartYear(d); handleChange('min_year_built', v); }}
                                  picker="year"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              span={2}
                              align="middle"
                              style={{ marginTop: 12 }}
                            >
                              <span>-</span>
                            </Col>
                            <Col span={11} className="hidden-label">
                              <Form.Item
                                label="Year built"
                                colon={false}
                                name="max_year_built"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Max Year built*!",
                                  },
                                ]}
                              >
                                <DatePicker
                                  onChange={(v, d) => { setEndYear(d); handleChange('max_year_built', v); }}
                                  picker="year"
                                  style={{ width: "100%" }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <Row gutter={[16, 0]} align="middle">
                            <Col span={11}>
                              <Form.Item
                                label="Stories"
                                colon={false}
                                name="min_no_of_stories"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Stories!",
                                  },
                                ]}
                              >
                                <Select
                                  allowClear
                                  showSearch
                                  placeholder="min no of stories"
                                  // defaultValue={"For Sale"}
                                  onChange={(value) => handleChange('miStories', value)}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  options={[
                                    { value: "1", label: "1" },
                                    { value: "2", label: "2" },
                                    { value: "3", label: "3" },
                                    { value: "4", label: "4" },
                                    { value: "5", label: "5" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                            <Col
                              span={2}
                              align="middle"
                              style={{ marginTop: 12 }}
                            >
                              <span>-</span>
                            </Col>
                            <Col span={11} className="hidden-label">
                              <Form.Item
                                label="Stories"
                                colon={false}
                                name="max_no_of_stories"
                                rules={[
                                  {
                                    required: false,
                                    message: "Please enter Stories!",
                                  },
                                ]}
                              >
                                <Select
                                  allowClear
                                  onChange={(value) => handleChange('maxStories', value)}
                                  showSearch
                                  placeholder="max no of stories"
                                  // defaultValue={"For Sale"}

                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.label ?? "")
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                  options={[
                                    { value: "1", label: "1" },
                                    { value: "2", label: "2" },
                                    { value: "3", label: "3" },
                                    { value: "4", label: "4" },
                                    { value: "5+", label: "5+" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12} className="hidden-label">
                          <Form.Item
                            label="HOA dues"
                            colon={false}
                            name="hoa_dues"
                            rules={[
                              {
                                required: false,
                                message: "Please enter HOA dues*!",
                              },
                            ]}
                          >
                            <Input
                              autoFocus="none"
                              onChange={(e) => handleChange('hoa_doues', e.target.value)}
                              type={"number"}
                              placeholder="Enter Hoa Fees"
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12} className="">
                          <Form.Item
                            colon={false}
                            name="parking"
                            rules={[
                              {
                                required: false,
                                message: "Please enter Parking*!",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              onChange={(value) => handleChange('parking', value)}
                              showSearch
                              placeholder="Parking"
                              // defaultValue={"For Sale"}

                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                { label: "Carport", value: "Carport" },
                                { label: "Off-Street", value: "Off-Street" },
                                {
                                  label: "Garage Attached",
                                  value: "Garage Attached",
                                },
                                { label: "On-Street", value: "On-Street" },
                                {
                                  label: "Garage Detached",
                                  value: "Garage Detached",
                                },
                                { label: "None", value: "None" },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12} className="">
                          <Form.Item
                            colon={false}
                            name="basement"
                            rules={[
                              {
                                required: false,
                                message: "Please enter Basement!",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              showSearch
                              placeholder="Basement"
                              // defaultValue={"For Sale"}
                              onChange={(value) => handleChange('basement', value)}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                { label: "Unfinished", value: "Unfinished" },
                                { label: "Carpet", value: "Carpet" },
                                {
                                  label: "Partially Finished",
                                  value: "Partially Finished",
                                },
                                { label: "None", value: "None" },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12} className="">
                          <Form.Item
                            colon={false}
                            name="heating_type"
                            rules={[
                              {
                                required: false,
                                message: "Please enter Heating Type!",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              showSearch
                              placeholder="Heating Type"
                              // defaultValue={"For Sale"}
                              onChange={(value) => handleChange('heatingType', value)}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                { label: "Baseboard", value: "Baseboard" },
                                { label: "Forced Air", value: "Forced Air" },
                                { label: "Geothermal", value: "Geothermal" },
                                { label: "Heat Pump", value: "Heat Pump" },
                                { label: "Radiant", value: "Radiant" },
                                { label: "Stove", value: "Stove" },
                                { label: "Wall", value: "Wall" },
                                { label: "Other", value: "Other" },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12} className="">
                          <Form.Item
                            colon={false}
                            name="cooling_type"
                            rules={[
                              {
                                required: false,
                                message: "Please enter Cooling Type!",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              showSearch
                              placeholder="Cooling Type"
                              // defaultValue={"For Sale"}
                              onChange={(value) => handleChange('coolingType', value)}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                { label: "Central", value: "Central" },
                                { label: "Evaporative", value: "Evaporative" },
                                { label: "Geothermal", value: "Geothermal" },
                                {
                                  label: "Refrigeration",
                                  value: "Refrigeration",
                                },
                                { label: "Solar", value: "Solar" },
                                { label: "Wall", value: "Wall" },
                                { label: "Other", value: "Other" },
                                { label: "None", value: "None" },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12} className="">
                          <Form.Item
                            colon={false}
                            name="view"
                            rules={[
                              {
                                required: false,
                                message: "Please Select View!",
                              },
                            ]}
                          >
                            <Select
                              allowClear
                              showSearch
                              placeholder="View"
                              // defaultValue={"For Sale"}

                              optionFilterProp="children" onChange={(value) => handleChange('view', value)}
                              filterOption={(input, option) =>
                                (option?.label ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              options={[
                                { label: "City", value: "City" },
                                { label: "Territorial", value: "Territorial" },
                                { label: "Mountain", value: "Mountain" },
                                { label: "Water", value: "Water" },
                                { label: "Park", value: "Park" },
                                { label: "None", value: "None" },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={12}></Col>
                        {/* <Col span={12} className="">
                        <Form.Item
                          colon={false}
                          name="sort"
                          rules={[
                            {
                              required: false,
                              message: "Please Select Sort!",
                            },
                          ]}
                        >
                          <Select
                            allowClear
                            showSearch
                            placeholder="Sort"
                            // defaultValue={"For Sale"}

                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={[
                              {
                                value: "In 2 day",
                                label: "In 2 day",
                              },
                              {
                                value: "In this week",
                                label: "In this week",
                              },
                              {
                                value: "In this month",
                                label: "In this month",
                              },
                              {
                                value: "Within 2 miles",
                                label: "Within 2 miles",
                              },
                              {
                                value: "Within 5 miles",
                                label: "In this month",
                              },
                              {
                                value: "Within 10 miles",
                                label: "Within 10 miles",
                              },
                              {
                                value: "Bedroom",
                                label: "Bedroom",
                              },
                              {
                                value: "Bathroom",
                                label: "Bathroom",
                              },
                              {
                                value: "Square feet",
                                label: "Square feet",
                              },
                              {
                                value: "Lot Size",
                                label: "Lot Size",
                              },
                              {
                                value: "Price low to high",
                                label: "Price low to high",
                              },
                              {
                                value: "Price high to low",
                                label: "Price high to low",
                              },
                            ]}
                          />
                        </Form.Item>
                      </Col> */}
                        <Col span={12} style={{ marginTop: 25 }} align="right">
                          <Form.Item>
                            <Button
                              type="primary"
                              htmlType="submit"
                              loading={false}
                            >
                              Submit
                            </Button>
                          </Form.Item>
                        </Col>
                        <Col span={12} style={{ marginTop: 25 }} align="left">
                          <Form.Item>
                            <Button
                              type="primary"
                              // onClick={() => form.resetFields() && setValues({})}
                              onClick={() => {
                                form.resetFields();
                                setValues({});
                                setBadgeCount(0);
                                actionGetAllProperty(0, 10);
                              }}
                            >
                              Reset
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              </Modal>
            </Col>

            <Col span={4} align="right">
              <Link to="/create-property">
                <Button>Create Property</Button>
              </Link>
            </Col>

            <Col span={24} style={{ marginTop: "10px" }}>
              <Table
                columns={columns}
                dataSource={tableData}
                // loading={propertiesLoader}
                sticky={true}
                onChange={(e) => onClickPagination(e)}
                size="small"
                pagination={{
                  total: propertiesCount, // add total Property Count Here
                  hideOnSinglePage: true,
                }}
                scroll={{
                  x: 1500,
                  y: window.innerWidth < 1500 ? "40vh" : "50vh",
                }}
              />
            </Col>
          </Row>
        </Space>
      </Spin>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    propertiesLoader: state.properties.propertiesLoader,
    propertiesData: state.properties.propertiesData,
    deletePropertyLoader: state.properties.deletePropertyLoader,
    propertiesCount: state.properties.propertiesCount,
    propertyDashboardLoader: state.properties.propertyDashboardLoader,
    propertyDashboardData: state.properties.propertyDashboardData,
  };
};

export default connect(mapStateToProps, {
  actionGetAllProperty,
  actionDeleteProperty,
  actionGetPropertyDashboardData
})(Property);
